<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchFor"
          label="Search"
          append-icon="search"
          @click:append="search"
          v-on:click="search"
          :rules="[rules.search]"
          :hint="hints.search()"
          @change="search"
          @keyup.native.enter="search"
          >
        </v-text-field>
      </v-card-title>

      <!-- list table -->
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="returnportals"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        v-if="state == 'list'"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-xs-left">{{ item.id }}</td>
            <td class="text-xs-left">{{ item.uuid }}</td>
            <td class="text-xs-left">{{ item.customer.customerId }}</td>
            <td class="text-xs-left">{{ item.customer.customerName1 }}</td>
            <td class="text-xs-left">{{ item.customer.customerName2 }}</td>
            <td>
              <router-link :to="`/returnshopportals/${item.uuid}`">Settings</router-link>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- search table-->
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="returnportals"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="loading"
        v-if="state == 'search'"
        :footer-props="footerProps"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-xs-left">{{ item.id }}</td>
            <td class="text-xs-left">{{ item.uuid }}</td>
            <td class="text-xs-left">{{ item.customer.customerId }}</td>
            <td class="text-xs-left">{{ item.customer.customerName1 }}</td>
            <td class="text-xs-left">{{ item.customer.customerName2 }}</td>
            <td>
              <router-link :to="`/returnshopportals/${item.uuid}`">Settings</router-link>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-layout>
      <v-flex xs2 style="margin-top:10px">
        <v-btn to="/returnshopportals/activate">New</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style module>
  .searchHighlight {
    background-color: lightyellow;
  }
</style>

<script>
  import axios from 'axios';
  import DataService from '../../services/data';

  export default {

    data() {
      return {
        totalItems: 0,
        loading: true,
        pagination: {rowsPerPage:10, sortBy:'id'},
        footerProps: {
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageOptions: [10,20,40]
        },
        searchFor: '',
        state: 'list',
        headline: '',
        headers: [
          {text: "Id", value: "id", sortable: false},
          {text: "UUID", value: "uuid", sortable: false},
          {text: "Customer Id", value: "customerId", sortable: false},
          {text: "Customer Name1", value: "customerName1", sortable: false},
          {text: "Customer Name2", value: "customerName2", sortable: false},
          {text: "Actions", value:"", sortable: false}
        ],
        returnportals: [],
        error: "",
        valid: true,
        rules: {
          search: () => this.valid || "Suchbegriff muss mindestens 3 Zeichen lang sein"
        },
        hints: {
          search: () => {
            return this.searchFor.length === 0 || this.searchFor.length > 2 ? "" : "Suchbegriff muss mindestens 3 Zeichen lang sein"
          }
        }
      }
    },

    computed: {
/*       sortBy() {
        let {sortBy, descending} = this.pagination;

        if(sortBy && sortBy==='customerId') {
          sortBy = 'customer.customerId'
        }

        if (descending) {
          sortBy = `${sortBy},desc`;
        }
        if (!sortBy) {
          sortBy = `id`;
        }

        return sortBy
      }  */
    },

    watch: {
      pagination: {
        handler: 'paginate',
        immediate: false
      }
    },

    created() {
      this.dataService = new DataService(this.profile, this.$store.state.tokens);
    },

    methods: {
      getItemPerPage(rows) {
      this.pagination.rowsPerPage = rows;
      this.paginate();
    },
      paginate() {

        if (this.searchFor) {
          return this.search(
            this.pagination.rowsPerPage,
            this.pagination.page,
            this.sortBy
          );
        }

        return this.fetchReturnPortals(
          this.pagination.rowsPerPage,
          this.pagination.page,
          this.sortBy
        );
      },

      fetchReturnPortals(size = 10, page = 1, sort = "id", descending = false) {
        this.loading = true;
        this.state = 'list';

/*         if (descending) {
          sort = `${sort},desc`;
        } */
        return this.dataService.getReturnShopPortals(page, this.pagination.rowsPerPage, sort)
          .then(this.updateDataTable)
          .catch(err => {
              this.error = err;
              this.loading = false;
            }
          );
      },

      search(size = 5, page = 0) {

        if (this.searchFor) {

          if (this.searchFor.length < 3) {
            this.valid = false;
            return false;
          }
          this.valid = true;

          this.state = 'search';
          this.loading = true;

          this.headline = `Suche : ${this.searchFor}`;

          this.dataService
            .searchReturnShopPortals(this.searchFor, this.pagination.rowsPerPage, this.pagination.page, this.sortBy)
            .then(this.updateDataTable)
            .catch(err => {
              this.error = err;
              this.loading = false;
            });
        } else {
          this.resetSearch();
        }
      },
      resetSearch() {
        this.searchFor = "";
        this.state = 'list';
        this.headline = '';
        this.valid = true;
        this.paginate();
      },
      updateDataTable(result) {
        this.returnportals = result.data.content;
        this.totalItems = result.data.totalElements;
        this.loading = false;
        return result;
      },
      getTooltip(contactCount, returnShopPortal) {
        if (contactCount === 0) {
          return 'Freischaltung nicht möglich';
        } else if (returnShopPortal) {
          return 'Öffnen';
        }
        return 'Freischalten';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?74e1afda